module.exports = __webpack_public_path__ + "static/media/RBG_art_Nicole_Pappas.334d0715.png";